/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "9.0.0";
